import { action, CubePresenter, FlipIntent, Logger } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import { ResultadoDetalhado, ShowResultadoDetalhado } from '../../bordero.types'
import { ResultadoDetalhadoAnaliseKeys } from '../resultado_detalhado_analise.keys'
import { DialogoResultadoKeys } from './dialogo-resultado.keys'
import DialogoResultadoScope from './dialogo-resultado.scopes'

const LOG = Logger.get('DialogoResultadoPresenter')

export class DialogoResultadoPresenter extends CubePresenter<MainPresenter, DialogoResultadoScope> {
    // :: Fields
    private __resultadoDetalhado?: ShowResultadoDetalhado

    // :: Constructor
    public constructor(app: MainPresenter) {
        super(app, new DialogoResultadoScope())
    }

    public override release() {
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new DialogoResultadoKeys(this.app, intent)

        keys.dialogSlot(this.scope)

        LOG.debug(`applyParameters ${keys.borderoId}`)

        if (initialization) {
            await this.#initialize()
        }

        if (
            Boolean(this.__resultadoDetalhado) !== Boolean(keys.resultadoDetalhadoShow) ||
            this.__resultadoDetalhado?.idOrigem !== keys.resultadoDetalhadoShow?.idOrigem
        ) {
            this.#applyResultadoDetalhado(keys.resultadoDetalhadoShow)
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new DialogoResultadoKeys(this.app, intent)

        LOG.debug(`publishParameters ${keys.borderoId}`)
    }

    async #applyResultadoDetalhado(res?: ShowResultadoDetalhado) {
        this.__resultadoDetalhado = res

        this.scope.origem = this.__resultadoDetalhado?.origem || ''
        this.scope.nome = this.__resultadoDetalhado?.nome || ''
        this.scope.documento = this.__resultadoDetalhado?.documento || ''
        this.scope.resultado = this.__resultadoDetalhado?.resultado || ({} as ResultadoDetalhado)
    }

    async #initialize() {
        LOG.debug('initialize')

        this.scope.onClose = this.handleClose.bind(this)
    }

    @action()
    private async handleClose() {
        await new ResultadoDetalhadoAnaliseKeys(this.app).flip()
    }
}

export default DialogoResultadoPresenter
